import React from 'react';
import { motion } from 'framer-motion';
import SectionShell from './Chapter';
import { SITE } from '@/constants/testIds';

const REGIONS = [
  {
    code: 'IN',
    name: 'India',
    body:
      'Full-lifecycle M&A, capital raising and strategic advisory for founders, promoters and enterprises nationwide.',
    cities: ['Mumbai', 'Delhi NCR', 'Bengaluru', 'Chennai'],
  },
  {
    code: 'ME',
    name: 'MENA',
    body:
      'Cross-border transaction execution and strategic project advisory across the key Middle East and North Africa markets.',
    cities: ['UAE', 'Saudi Arabia', 'Egypt', 'Qatar'],
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    body:
      'Asia-hub deal execution and JV structuring — Hong Kong as a gateway between India, MENA and Greater China.',
    cities: ['Central', 'Kowloon', 'Greater China', 'APAC'],
  },
];

export const Reach = () => {
  const ease = [0.22, 1, 0.36, 1];
  return (
    <SectionShell
      id="reach"
      testId={SITE.reach}
      theme="dark"
      index="08"
      eyebrow="Geographic Reach"
      title={
        <>
          Three corridors where founder capital and cross-border ambition
          intersect.
        </>
      }
      intro="Deep local relationships combined with international grammar. We move where founders and family offices are actively deploying capital, forming partnerships and executing exits."
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {REGIONS.map((r, i) => (
          <motion.article
            key={r.code}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px' }}
            transition={{ duration: 0.75, delay: i * 0.08, ease }}
            className="border border-[color:var(--rule-dark-2)] rounded-sm p-6 md:p-8 flex flex-col"
          >
            <div className="flex items-center justify-between small-caps text-[10.5px] text-[color:var(--stone-3)]">
              <span className="text-[color:var(--gold-2)]">{r.code}</span>
              <span>Region 0{i + 1}</span>
            </div>
            <h3 className="mt-8 font-serif text-[36px] md:text-[42px] leading-[1.02] tracking-[-0.02em] text-[color:var(--stone)]">
              {r.name}
            </h3>
            <p className="mt-5 text-[14.5px] leading-[1.6] text-[color:var(--stone-2)]">
              {r.body}
            </p>
            <div className="mt-8 pt-6 border-t border-[color:var(--rule-dark)]">
              <p className="small-caps text-[10.5px] text-[color:var(--stone-3)]">
                Coverage
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {r.cities.map((c) => (
                  <span
                    key={c}
                    className="px-2.5 py-1 border border-[color:var(--rule-dark)] rounded-full text-[11.5px] tracking-[0.04em] text-[color:var(--stone)]"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </SectionShell>
  );
};

export default Reach;
